import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ShowroomHero from "./components/ShowroomHero";
import ShowroomSpaces from "./components/ShowroomSpaces";
import ShowroomGallery from "./components/ShowroomGallery";
import ShowroomExperience from "./components/ShowroomExperience";
import ShowroomVisit from "./components/ShowroomVisit";

export default function ShowroomPage() {
  return (
    <main className="min-h-screen bg-[#0d0d0d]">
      <Navbar />
      <ShowroomHero />
      <ShowroomSpaces />
      <ShowroomGallery />
      <ShowroomExperience />
      <ShowroomVisit />
      <Footer />
    </main>
  );
}
